export default __webpack_public_path__ + "static/media/Client.8c113306.jpg";